export {default} from '../home/Home';



// WEBPACK FOOTER //
// ./src/components/async/Home.js